export const supportedLocales = ["en", "am"]

// For client-side fetching (without async/await)
export const getMessages = async (locale: string, namespace: string) => {
  if (!supportedLocales.includes(locale)) {
    locale = "en" // Fallback to default locale
  }

  try {
    // Dynamically import translation files based on locale and namespace
    switch (locale) {
      case "am":
        return await import(`../../locales/am/${namespace}.json`)
      case "en":
      default:
        return await import(`../../locales/en/${namespace}.json`)
    }
  } catch (error) {
    console.error(`Error loading translation for locale '${locale}' and namespace '${namespace}':`, error)
    return {}
  }
}
